import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'

const base = config.baseApi + '/merchant/wechat-shop'
const unwrap = (response) => {
  if (!response || Number(response.code) !== 200) {
    const error = new Error(response?.message || '微信批量修改请求失败')
    error.code = Number(response?.code || 500)
    throw error
  }
  return response.data
}
const shelfPath = (feature) => base + (feature === 'timer' ? '/timer-status-batch' : '/status-batch')

export const getWechatBatchShops = () => request.get(base + '/batch/shops', {}).then(unwrap)
export const getWechatBatchCategories = () => request.get(config.baseApi + '/merchant/product/category/list', { shop_type: 7 }).then(unwrap)
export const getWechatBatchProducts = (data) => request.post(base + '/batch/products', data).then(unwrap)
export const previewWechatShelfBatch = (feature, data) => request.post(shelfPath(feature) + '/preview', data).then(unwrap)
export const createWechatShelfBatch = (feature, data) => request.post(shelfPath(feature), data).then(unwrap)
export const getWechatBatchList = (data) => request.get(base + '/batch', data).then(unwrap)
export const getWechatBatchDetails = (id, data) => request.get(base + '/batch/' + id + '/details', data).then(unwrap)
export const cancelWechatBatch = (id) => request.post(base + '/batch/' + id + '/cancel', {}).then(unwrap)
